<template>
    <div>
        <div class="d-flex align-items-center mb-3 flex-wrap" style="gap:8px">
            <label class="mb-0 mr-1 font-weight-bold"><i class="fas fa-mobile-alt text-primary"></i> Filter Pengirim (Device):</label>
            <select class="form-control form-control-sm w-auto" v-model="deviceFilter" @change="onDeviceFilterChange">
                <option value="">Semua Device</option>
                <option v-for="d in devices" :key="d.id" :value="d.id">{{ d.name }}</option>
            </select>
        </div>
        <vue-good-table mode="remote" @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter"
            :isLoading.sync="table.isLoading" :pagination-options="{
          enabled: false
        }" :columns="table.columns" :rows="table.rows">
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action'">
                    <router-link :to="'/incoming/detail?id=' + props.row.id">
                        <a class="btn btn-primary btn-sm text-white margin5">Detail</a>
                    </router-link>
                    <a v-on:click="deleteIncoming(props.row.id)" class="btn btn-danger btn-sm text-white margin5">
                        Hapus
                    </a>
                </span>
                <span v-else-if="props.column.field == 'text'">
                    {{ cutString(props.row.text) }}
                    <div v-if="props.row.file">
                        <br>
                        <div class="card">
                            <div class="card-body">
                                <center>
                                    <b>Document</b>
                                    <br>
                                    <a :href="props.row.file" target="_blank"> Open File </a>
                                </center>
                            </div>
                        </div>
                    </div>
                </span>
                <span v-else-if="props.column.field == 'created_at'">
                    {{ convertDateToLocal(props.row.created_at) }}
                </span>
                <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                </span>
            </template>
        </vue-good-table>
        <div class="d-flex align-items-center justify-content-between mt-2">
            <div class="d-flex align-items-center">
                <label class="mr-2 mb-0">Per page</label>
                <select class="form-control form-control-sm w-auto" v-model.number="table.serverParams.limit" @change="onLimitChange">
                    <option :value="10">10</option>
                    <option :value="25">25</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                </select>
            </div>
            <div class="d-flex align-items-center">
                <span class="text-muted small mr-3" v-if="table.rows && table.rows.length">Showing {{ table.rows.length }} items</span>
                <div class="btn-group" role="group" aria-label="Pagination controls">
                    <button
                        class="btn btn-sm btn-outline-primary"
                        :disabled="cursorStack.length === 0 || table.isLoading"
                        @click="goPrevPage"
                        title="Go to previous page"
                        aria-label="Previous">
                        <i class="fas fa-chevron-left"></i>
                        <span class="d-none d-sm-inline"> Previous</span>
                    </button>
                    <button
                        class="btn btn-sm btn-outline-primary"
                        :disabled="!hasMore || table.isLoading"
                        @click="goNextPage"
                        title="Go to next page"
                        aria-label="Next">
                        <span class="d-none d-sm-inline">Next </span>
                        <i class="fas fa-chevron-right"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        data() {
            return {
                table: {
                    isLoading: true,
                    columns: [{
                            label: "Pengirim",
                            field: "number",
                            filterOptions: {
                                enabled: true,
                            },
                            sortable: false,
                            width: "15%",
                        },
                        {
                            label: "Text",
                            field: "text",
                            filterOptions: {
                                enabled: true,
                            },
                            sortable: false,
                            width: "40%",
                        },
                        {
                            label: "Diterima Pada",
                            field: "created_at",
                            filterOptions: {
                                enabled: false,
                            },
                            sortable: false,
                            width: "25%",
                        },
                        {
                            label: "Action",
                            field: "action",
                            sortable: false,
                            width: "20%",
                        },
                    ],
                    rows: [],
                    serverParams: {
                        columnFilters: {},
                        sort: [{
                            field: "",
                            type: "",
                        }, ],
                        limit: 10,
                        last_id: null,
                    },
                },
                hasMore: false,
                cursorStack: [],
                devices: [],
                deviceFilter: "",
            };
        },
        mounted() {
            this.fn = () => {
                this.loadItems();
            }
            this.$root.$on("refresh_table", this.fn);
            this.loadDevices();
            this.loadItems();
        },
        beforeDestroy() {
            this.$root.$off("refresh_table", this.fn);
        },
        methods: {
            cutString(string) {
                if(string == null || string == "") return ""

                if (string.length > 40) {
                    string = string.slice(0, 40) + "..."
                }

                return string
            },
            convertDateToLocal(date) {
                return moment.utc(date).local().format("YYYY-MM-DD HH:mm:ss")
            },
            async deleteIncoming(id) {
                try {
                    let response = await this.$store.dispatch("incoming_delete", {
                        id: id
                    });
                    this.loadItems();
                    this.$toast.success(response.data.message);
                } catch (err) {
                    this.$toast.error("Server error");
                }
            },
            updateParams(newProps) {
                this.table.serverParams = Object.assign({},
                    this.table.serverParams,
                    newProps
                );
            },
            async loadDevices() {
                try {
                    let res = await this.$store.dispatch("device_list_all", { limit: 1000, page: 1 });
                    this.devices = (res.data && res.data.data && res.data.data.devices) ? res.data.data.devices : [];
                } catch (err) {
                    this.devices = [];
                }
            },
            onDeviceFilterChange() {
                this.cursorStack = [];
                this.updateParams({ last_id: null });
                this.loadItems();
            },
            onLimitChange() {
                this.updateParams({
                    limit: this.table.serverParams.limit,
                    last_id: null
                });
                this.cursorStack = [];
                this.loadItems();
            },
            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params.sortType,
                        field: this.table.columns[params.columnIndex].field,
                    }, ],
                    last_id: null,
                });
                this.cursorStack = [];
                this.loadItems();
            },
            onColumnFilter(params) {
                this.updateParams(Object.assign({}, params, { last_id: null }));
                this.cursorStack = [];
                this.loadItems();
            },
            goPrevPage() {
                if (this.cursorStack.length > 0) {
                    const prevCursor = this.cursorStack.pop();
                    this.updateParams({ last_id: prevCursor });
                    this.loadItems();
                }
            },
            goNextPage() {
                if (this.hasMore) {
                    this.cursorStack.push(this.table.serverParams.last_id);
                    const rows = this.table.rows || [];
                    const nextCursor = rows.length > 0 ? rows[rows.length - 1].id : null;
                    this.updateParams({ last_id: nextCursor });
                    this.loadItems();
                }
            },
            async loadItems() {
                this.table.isLoading = true
                try {
                    let response = await this.getFromServer(this.table.serverParams);
                    let incoming = response.data.data.incomings;
                    // for (let i = 0; i < outgoing.length; i++) {
                    //     if(outgoing[i].message_type == "button"){
                    //         outgoing[i].parsedButton = await JSON.parse(outgoing[i].data)
                    //         outgoing[i].footer = outgoing[i].parsedButton[0].footer
                    //     }
                    // }
                    this.table.rows = incoming
                    this.hasMore = Array.isArray(incoming) && incoming.length === this.table.serverParams.limit
                } catch (err) {
                    console.log(err)
                    this.$toast.error("Too many request");
                }
                this.table.isLoading = false
            },
            async getFromServer(param) {
                const payload = {
                    limit: param.limit,
                };
                if (param.last_id) {
                    payload.last_id = param.last_id;
                }
                const mergedFilters = Object.assign({}, param.columnFilters || {});
                if (this.deviceFilter) {
                    mergedFilters.device_id = String(this.deviceFilter);
                }
                if (Object.keys(mergedFilters).length) {
                    payload.columnFilters = JSON.stringify(mergedFilters);
                }
                if (param.sort && param.sort.length && param.sort[0].field) {
                    payload.sort = param.sort;
                }
                return await this.$store.dispatch("incoming_list", payload);
            },
        },
    };
</script>

<style scoped>
    .margin5 {
        margin: 5px;
    }
</style>